import { Money, type MoneyJson } from '@klear/money'
import type { PaymentLineItemType } from '@klear/payment/constants'
import type { PaymentItemWire } from '@klear/payment/item.wire'

export type PaymentItem = {
  id?: number
  type: PaymentLineItemType
  amount: Money
  note?: string
}

export type PaymentItemInput = Omit<PaymentItem, 'amount'> & {
  amount: Money | MoneyJson
}

export function hasUnpricedItem(items: PaymentItemWire[]): boolean {
  return items.some((item) => new Money(item.amount).isZero())
}
